import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import { products } from '@/mixins/products';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import ProductFeedOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('product-feed', {
  template: require('./template.html'),
  name: 'product-feed',
  mixins: [cssGenerator, products],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    storeData() {
      return this.currentSite.dynamic && this.currentSite.dynamic.products;
    },
    currencyType() {
      const enabled = this.storeData;
      const symbols = {
        USD: '&#36;',
        CAD: '&#36;',
        EUR: '&#128;',
      };
      const type = enabled && enabled.currency ? enabled.currency : 'USD';
      return {
        type: type.toLowerCase(),
        symbol: symbols[type],
      };
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    feed() {
      const enabled = this.storeData;
      const list = enabled ? _.cloneDeep(enabled.published || []) : [];
      // set by newest by default
      let sorted = list.sort((a, b) => new Date(b.publishedOn) - new Date(a.publishedOn));
      if (this.droplet.sort === 'oldest') {
        sorted = sorted.reverse();
      }
      if (this.droplet.filters.length > 0) {
        // match all option
        if (this.droplet.match === 'all') {
          sorted = sorted.filter(
            p => this.droplet.filters.every(f => p.categories.indexOf(f) > -1),
          );
        }
        // match some option
        if (this.droplet.match === 'some') {
          sorted = sorted.filter(
            p => this.droplet.filters.some(f => p.categories.indexOf(f) >= 0),
          );
        }
      }
      return sorted.slice(0, this.droplet.itemCount);
    },
    displayedFeed() {
      const feed = [...this.feed];
      return feed.slice(Math.max(feed.length - this.droplet.itemCount, 0));
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzProduct-feed' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        'box-shadow': null,
        'border-width': null,
        'font-size': null,
        'line-height': null,
        'letter-spacing': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    ProductFeedOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzProduct-feed',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-feed/index.js